import {
  AutocompleteInput,
  ArrayInput,
  BooleanInput,
  Edit,
  ReferenceInput,
  required,
  SelectInput,
  SimpleForm,
  SimpleFormIterator,
  TextInput,
} from 'react-admin';
import { PLACE_TYPE_CHOICES, PLACE_REGION_CHOICES, PLACE_PHONE_LABEL_CHOICES } from './PlacesCreate';

export const PlacesEdit = () => (
  <Edit>
    <SimpleForm>
      <TextInput source="name" validate={[required()]} />
      <TextInput source="abbreviation" />
      <TextInput source="address" />
      <TextInput source="city" />
      <TextInput source="state" label="Province" />
      <TextInput source="postal_code" />
      <TextInput source="maps_link" />

      <SelectInput source="type" validate={[required()]} choices={PLACE_TYPE_CHOICES} />
      <SelectInput source="region" choices={PLACE_REGION_CHOICES} helperText="Leave empty to apply to both provinces" />
      <TextInput source="phone_number" label="Primary phone" />
      <ArrayInput source="phones" label="Phone lines (admitting, pathology, …)">
        <SimpleFormIterator inline>
          <SelectInput source="label" choices={PLACE_PHONE_LABEL_CHOICES} helperText={false} />
          <TextInput source="number" helperText={false} />
          <TextInput source="ext" label="Ext." helperText={false} />
        </SimpleFormIterator>
      </ArrayInput>

      <ReferenceInput reference="places" source="parent_id" filter={{ type: 'Cemetery' }}>
        <AutocompleteInput optionText="name" label="Section Of" helperText={false} />
      </ReferenceInput>
      <BooleanInput source="active" />
      <BooleanInput source="display_on_website" />
    </SimpleForm>
  </Edit>
);
